import { ASSET_BASE_URL } from '@/config';

export default ASSET_BASE_URL;
